/**
 * utils/recipeMatch.js
 * Pure helper: does a transformation combo already exist as a saved recipe?
 * A combo matches a recipe iff same `type` AND identical input + output line-sets,
 * compared order-independently with quantities summed per internalCode (blank/≤0 lines dropped).
 * Used by Transformasi to decide whether to offer the post-run "save as recipe" modal.
 */
const sig = (lines = []) => {
  const sums = new Map();
  for (const l of lines) {
    const code = l.internalCode;
    const qty = Number(l.qty) || 0;
    if (!code || qty <= 0) continue;
    sums.set(code, (sums.get(code) || 0) + qty);
  }
  return [...sums.entries()]
    .sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0))
    .map(([c, q]) => `${c}:${q}`)
    .join("|");
};

/** Canonical signature of a { type, inputs, outputs } combo. */
export const comboSignature = (combo) =>
  `${combo.type}#${sig(combo.inputs)}#${sig(combo.outputs)}`;

/** First recipe whose type + lines match the combo, else null. */
export const findMatchingRecipe = (recipes = [], combo) => {
  const target = comboSignature(combo);
  return (
    recipes.find(
      (r) => comboSignature({ type: r.type, inputs: r.inputs, outputs: r.outputs }) === target
    ) || null
  );
};
